export class Violation {
    constructor(
        public readonly id: number,
        public readonly conflicts: number[],
        public readonly name: string,
        public readonly description: string,
        public readonly symbol: string,
        public readonly i18n: Record<string, { name: string; desc: string }>,
        public readonly indisputable: boolean = false,
        // Czy nakładający może sam zdecydować o bezsporności reklamacji (nadpisać indisputable).
        public readonly indisputableOverridable: boolean = false
    ) { }

    /**
     * Czy uchybienie można nałożyć z zadaną bezspornością reklamacji.
     */
    canBeImposedAs(indisputable: boolean): boolean {
        return this.indisputableOverridable || this.indisputable === indisputable;
    }

    /**
     * Czy reklamacja z tym uchybieniem jest zawsze bezsporna, niezależnie od wyboru nakładającego.
     */
    isAlwaysIndisputable(): boolean {
        return this.indisputable && !this.indisputableOverridable;
    }
}
